import { Pipe, PipeTransform } from '@angular/core';

const ALLOWED_PROTOCOLS = new Set(['http:', 'https:', 'mailto:', 'tel:']);

@Pipe({
	name: 'safeUrl',
	standalone: true,
})
export class SafeUrlPipe implements PipeTransform {
	transform(value: unknown): string | null {
		if (typeof value !== 'string' || !value.trim()) {
			return null;
		}

		try {
			const url = new URL(value, globalThis.location.origin);
			return ALLOWED_PROTOCOLS.has(url.protocol) ? value : null;
		} catch {
			return null;
		}
	}
}
